<section id="Introduction">
    <div class="row">
        <div class="body-section">
            <div class="column medium-4 before-show">
                <h3 class="num">
                    ۲۸ </h3>
                <p class="txt1">
                    سال </p>
                <p class="txt2">
                    سابقه فعالیت </p>
            </div>
            <div class="column medium-4 before-show">
                <h3 class="num">
                    ۳۰۰۰ </h3>
                <p class="txt1">
                    میلیارد تومان </p>
                <p class="txt2">
                    سرمایه تحت مدیریت </p>
            </div>
            <div class="column medium-4 before-show">
                <h3 class="num">
                    ۲۰۰۰۰۰ </h3>
                <p class="txt1">
                    سرمایه‌گذار </p>
                <p class="txt2">
                    در صندوق‌های آبان </p>
            </div>
        </div>
    </div>
</section>